import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './right-outer.styl'

export default class RightOuter extends Component {
  static propTypes = {
    children: PropTypes.any
  }

  render() {
    return (
      <div className={styles.wrap}>
        {this.props.children}
      </div>
    )
  }
}
